module.exports = __webpack_public_path__ + "static/media/event_detect.fe960763.svg";